var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.condition)?_c('i',{staticClass:"fas fa-check text-primary"}):_c('i',{staticClass:"text-danger fas fa-times-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }